import "./circleLoader.css";

const CircleLoader = ({ color = "#BF5ADE" }) => {
    return <span className="circle-loader" style={{ borderBottomColor: color }}></span>;
};

export default CircleLoader;
